import { createAuthClient } from 'better-auth/react';
import { adminClient } from 'better-auth/client/plugins';

/**
 * Better Auth client for authentication operations
 * Provides type-safe authentication methods and session management
 * Uses React-specific client for hooks and React integration
 */
import { API_ORIGIN } from './api-config.js';

export const authClient = createAuthClient({
  baseURL: `${API_ORIGIN}/auth`,
  fetchOptions: {
    credentials: 'include', // Required for cookies to work across ports
    onError: async (context) => {
      const { response } = context;

      // Handle specific error cases
      if (response?.status === 401) {
        // Session expired - redirect to login
        console.warn('[AUTH_CLIENT] Session expired, redirecting to login');
        window.location.href = '/login';
      }

      if (response?.status === 429) {
        // Rate limited - show user-friendly message
        console.error('[AUTH_CLIENT] Rate limit exceeded. Please try again later.');
      }
    },
  },
  plugins: [
    adminClient(), // Enable admin plugin on client
  ],
});

/**
 * Type helper for session data
 * Inferred from the auth client for type safety
 */
export type Session = typeof authClient.$Infer.Session;

/**
 * Type helper for user data
 * Inferred from the session type for type safety
 */
export type User = Session['user'];
